import React, {useEffect, useState} from "react";
import {Dropdown, DropdownChangeParams} from "primereact/dropdown";
import {useGetDatasetCategories} from "api/api-hooks/datasets-hooks";

interface IDatasetCategoryDropdownProps {
    // Category ID
    value?: number | null;
    onChange?: (e: number) => void;
    className?: string;
    disabled?: boolean;
}

interface DropdownItem {
    value: string | number,
    label: string,
}

export function DatasetCategoryDropdown(props: IDatasetCategoryDropdownProps) {
    const [allSelections, setAllSelections] = useState<DropdownItem[]>([]);

    const query = useGetDatasetCategories();

    useEffect(() => {
        if(query.data){
            const selections = query.data.map((it) => ({ value: it.id, label: it.toString() } as DropdownItem))
            setAllSelections(selections)
        }
    }, [query.data])

    const onChange = (e: DropdownChangeParams) => {
        if(props.onChange == null) return

        props.onChange(e.target.value)
    }

    return <>
        { query.error &&
            <span>Something went wrong with dataset category dropdown!</span>
        }

        { query.isLoading && !query.error &&
            <span>Dataset category dropdown loading...</span>
        }

        { !query.isLoading &&
            <Dropdown placeholder="Select Dataset Category"
                      className={props.className}
                      value={props.value}
                      options={allSelections}
                      filter={true}
                      filterMatchMode="contains"
                      onChange={onChange}
                      optionLabel="label"
                      optionValue="value"
                      disabled={props.disabled}
            />
        }
    </>
}